/**
 * Labstep
 *
 * @module components/Entity/Template/Breadcrumb/Show
 * @desc Breadcrumb for Template Entities on Show page
 */

import { Breadcrumb } from 'labstep-web/core/Breadcrumb';
import type { IBreadcrumbLink } from 'labstep-web/core/Breadcrumb/types';
import type React from 'react';
import type { EntityTemplateBreadcrumbShowProps } from './types';

export const EntityTemplateBreadcrumbShow: React.FC<
  EntityTemplateBreadcrumbShowProps
> = ({ entity }) => {
  if (!entity.template) {
    return null;
  }
  const links: IBreadcrumbLink[] = [
    {
      icon: 'box',
      name: entity.template.displayName as string,
      route: {
        to: `${entity.entityName}_index`,
        query: {
          template_id: entity.template.guid,
        },
      },
    },
  ];

  return <Breadcrumb links={links} />;
};
